import BaseValidator from '@/lib/data/validator/BaseValidator'

export default class UserValidator extends BaseValidator {
  validatorRules = {}

  validatorMessages = {
    el: {},
    en: {}
  }

  constructor (data = {}) {
    super(data)
  }
}
